import { useState, useRef, useMemo } from 'react';
import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import ContactInformation from '@Components/Shared/ContactInformation';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import { useRecoilValue } from 'recoil';
import atoms from '@Components/Utilities/SandhillsAtoms';

const FeedbackModal = loadable(() => import('@Components/Shared/Modals/FeedbackModal'), true);

const ContactUsView = (props) => {
    const [showFeedbackModal, setShowFeedbackModal] = useState(props.ShowFeedbackModalOnLoad);
    const [modalSubject, setModalSubject] = useState(null);
    const ref = useRef(null);
    const currentSite = useRecoilValue(atoms.currentWebsite);
    const routes = useRecoilValue(atoms.routes);
    const toggleFeedbackModal = (subject) => {
        // If a specific subject string is passed, set it. Otherwise clear it to use default order.
        const targetSubject = typeof subject === 'string' ? subject : null;

        if (!showFeedbackModal) {
            setModalSubject(targetSubject);
        }

        setShowFeedbackModal(showFeedbackModal => !showFeedbackModal);
        if (showFeedbackModal && ref?.current) {
            setTimeout(() => {
                ref.current.focus();
            }, 150);
        }
    }

    const effectiveDropDown = useMemo(() => {
        // If modal (i.e. "Become An Auctioneer") button is clicked, move the appropriate option to the top
        if (!modalSubject || !props.SubjectDropDown) return props.SubjectDropDown;

        const list = [...props.SubjectDropDown];
        const index = list.findIndex(x => x.Value === modalSubject);

        if (index > -1) {
            const item = list.splice(index, 1)[0];
            list.unshift(item);
        }
        return list;
    }, [props.SubjectDropDown, modalSubject]);

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleFeedbackModal();
        }
    }

    return (
        <div className='info-content-container'>
            <div className='info-content-header'>
                <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
                <h1 className='pagename border-bottom'>{props.PageTitle}</h1>
            </div>
            {!props.UseSEOHTagReorganization ?
                <div className='contact-us-container'>
                    {props.AuctioneerUrl && <p>
                        <TranslationText tKey='sandhills.tradesites.mvc.lookingforauctioneers' />
                        <span className='click-here capitalize'> <a id='contact-us-auctioneer-search' href={props.AuctioneerUrl} aria-label={translator.translate('sandhills.tradesites.mvc.viewallauctioneers')}><TranslationText tKey='sandhills.tradesites.mvc.viewallauctioneers' /></a></span>
                    </p>}
                    {props.PartsSearchUrl && <p>
                        <TranslationText tKey='sandhills.tradepubwebsite.mvc.lookingforparts' />
                        <span className='click-here'> <a id='contact-us-parts-search' href={props.PartsSearchUrl} aria-label={translator.translate('sandhills.tradesites.mvc.findparts')}><TranslationText tKey='sandhills.tradesites.mvc.findparts' /></a></span>
                    </p>}
                    {props.ListingInputUrl && !currentSite?.Site.IsAuctionTime &&
                        <p>
                            <TranslationText tKey='sandhills.tradepubwebsite.mvc.havesomethingforsale' />
                            <span className='click-here'> <a id='contact-us-listing-input' href={props.ListingInputUrl} aria-label={props.ListingInputAcessibleText}>{props.ListingInputAcessibleText}</a></span>
                        </p>}
                    {currentSite?.Site.IsAuctionTime &&
                        <p>
                            {translator.translate('sandhills.tradepubwebsite.mvc.havesomethingtoauction')}
                            <span className='click-here'> <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); toggleFeedbackModal('BecomeAuctioneer'); } }} id='contact-us-listing-input' onClick={() => toggleFeedbackModal("BecomeAuctioneer")} aria-label={props.ListingInputAcessibleText}>{props.ListingInputAcessibleText}</a></span>
                        </p>
                    }
                    <p>
                        <TranslationText tKey='sandhills.tradepubwebsite.mvc.wouldyouliketoleaveusanemailmessage' />
                        <span className='click-here' ref={ref} tabIndex={0} role='button' onClick={toggleFeedbackModal} onKeyDown={handleKeyPress} aria-label={translator.translate('sandhills.tradepubwebsite.mvc.sendusafeedbackemail')}>&nbsp;<TranslationText tKey='Sandhills.TradePubWebSite.MVC.SendUsAFeedbackEmail' /></span>
                    </p>
                    <p><TranslationText tKey='sandhills.tradepubwebsite.mvc.pleaseincludeaphoneorfaxnumber' /></p>
                    <p><TranslationText tKey='sandhills.tradepubwebsite.mvc.weencourageyoutocontactus' /></p>
                    <br />
                    <ContactInformation {...props.ContactInformation}
                        UseSEOHTagReorganization={props.UseSEOHTagReorganization}
                    />
                    {showFeedbackModal &&
                        <FeedbackModal
                        {...props}
                            SubjectDropDown={effectiveDropDown}
                            toggleModal={toggleFeedbackModal}
                            title={translator.translate('sandhills.tradepubwebsite.mvc.feedbackemail')}
                        />}
                </div>
                :
                <div className='contact-us-container'>
                    {props.AuctioneerUrl &&
                        <><div class="inline-block">
                            <span className='click-here'> <a id='contact-us-auctioneer-search' href={props.AuctioonerUrl} aria-label={translator.translate('sandhills.tradesites.mvc.lookingforauctioneers')}><h2 className="header-reset"><TranslationText tKey='sandhills.tradesites.mvc.lookingforauctioneers' /></h2></a></span>
                        </div>
                            <br />
                        </>}
                    {props.PartsSearchUrl &&
                        <><div class="inline-block">
                            <h2 className="header-reset"><TranslationText tKey='sandhills.tradepubwebsite.mvc.lookingforparts' /></h2>
                        </div>
                            <span className='click-here'> <a id='contact-us-parts-search' href={props.PartsSearchUrl} aria-label={translator.translate('sandhills.tradesites.mvc.findparts')}><TranslationText tKey='sandhills.tradesites.mvc.findparts' /></a></span>
                            <br />
                        </>}
                    {props.ListingInputUrl &&
                        <>
                            <div class="inline-block">
                                <h2 className="header-reset"><TranslationText tKey='sandhills.tradepubwebsite.mvc.havesomethingforsale' /></h2>
                            </div>
                            <span className='click-here'> <a id='contact-us-listing-input' href={props.ListingInputUrl} aria-label={props.ListingInputAcessibleText}><TranslationText tKey='Sandhills.SellYourEquipment' /></a></span>
                            <br />
                            <div class="inline-block">
                                <h2 className="header-reset"><TranslationText tKey='sandhills.tradepubwebsite.mvc.wouldyouliketoleaveusanemailmessage' /></h2>
                            </div>
                            <span className='click-here'> <a id='contact-us-send-feedback' ref={ref} tabIndex={0} role='button' onClick={toggleFeedbackModal} onKeyDown={handleKeyPress} aria-label={translator.translate('sandhills.tradepubwebsite.mvc.sendusafeedbackemail')}><TranslationText tKey='Sandhills.TradePubWebSite.MVC.SendUsAFeedbackEmail' /></a></span>
                        </>}
                    <br /><span class="inline-block"><TranslationText tKey='sandhills.tradepubwebsite.mvc.pleaseincludeaphoneorfaxnumber' /></span>
                    <br /><span class="inline-block"><TranslationText tKey='sandhills.tradepubwebsite.mvc.weencourageyoutocontactus' /></span><br />
                    <br />
                    <ContactInformation {...props.ContactInformation}
                        UseSEOHTagReorganization={props.UseSEOHTagReorganization}
                    />
                    {showFeedbackModal &&
                        <FeedbackModal
                        {...props}
                            toggleModal={toggleFeedbackModal}
                            title={translator.translate('sandhills.tradepubwebsite.mvc.feedbackemail')}
                        />}
                </div>
            }
            {props.ContactInformation.IsCharterHub && <img src={routes.CDNBaseUrl + 'Images/FooterBrands/CharterHub_Airplane.png'} className='footer-icon' alt={translator.translate('sandhills.aircraft')} />}
        </div>
    );
};

export default ContactUsView;
global.ContactUsView = ContactUsView;